export default __webpack_public_path__ + "static/media/Ass_1.1151459c.svg";